/**
 * Created by nicom on 8/1/2017.
 */

import React, { Component } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

class CustomChart extends Component {
  render() {
    const data = this.props.data.GetDataObject();
    const options = {
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          callbacks: {
            title: () => "",
            label: (context) => {
              let label = context.label || "";
              let percentage = context.parsed + "%";
              return label + ": " + percentage;
            },
          },
        },
        legend: {
          display: true,
        },
      },
    };
    return (
      <div className="chartContainer">
        <Pie data={data} options={options} />
      </div>
    );
  }
}

export default CustomChart;
